// React
import axios from 'axios';

import {
  BASE_URL,
  USER_SERVICE,
  CAPABILITIES,
  VERSION_1,
  SERVICE_VERSION
} from './configuration';
import { USER_SERVICE_ENDPOINT } from './configuration/user-service';
import store from '../store';
import { utf8Encode } from '../utils';

export const USER_SERVICE_CAPABILITIES_URL = `${BASE_URL}/${USER_SERVICE}/${CAPABILITIES}/${VERSION_1}`;
export const USER_SERVICE_URL = `${BASE_URL}/${USER_SERVICE}/${SERVICE_VERSION}`;

export const getTenantMap = (companyId) => {
  return (dispatch) =>
    axios({
      method: 'GET',
      url:
        USER_SERVICE_CAPABILITIES_URL +
        USER_SERVICE_ENDPOINT.TENANT_MAP +
        '?companyId=' +
        companyId
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: 'ERROR',
          error: error
        });
      });
};

export const updateSupplierAttributes = (payload) => {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_SUPPLIER_ATTRIBUTES',
      payload: payload
    });
  };
};

export const createPickupAddress = (payload) => {
  return async (dispatch) => {
    dispatch({
      type: 'SET_LOADER',
      payload: true
    });
    try {
      const response = await axios({
        method: 'POST',
        url: USER_SERVICE_CAPABILITIES_URL + USER_SERVICE_ENDPOINT.PICKUP_ADDRESS,
        data: payload
      });
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
      return response.data;
    } catch (error) {
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
      dispatch({
        type: 'ERROR',
        error: error
      });
    }
  };
};

export const postUserQuery = (payload) => {
  return async (dispatch) => {
    dispatch({
      type: 'SET_LOADER',
      payload: true
    });
    try {
      const response = await axios({
        method: 'POST',
        url: USER_SERVICE_URL + USER_SERVICE_ENDPOINT.USER_QUERY,
        data: payload
      });
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
      return { success: true, data: response.data };
    } catch (error) {
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
      dispatch({
        type: 'ERROR',
        error: error.response
      });
      return { success: false, error: error.response };
    }
  };
};

export const getPickupAddress = (companyId) => {
  return async (dispatch) => {
    dispatch({
      type: 'SET_LOADER',
      payload: true
    });
    try {
      const response = await axios({
        method: 'GET',
        url:
          USER_SERVICE_CAPABILITIES_URL +
          USER_SERVICE_ENDPOINT.GET_PICKUP_ADDRESS +
          '/' +
          companyId
      });
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
      return response.data;
    } catch (error) {
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
      dispatch({
        type: 'ERROR',
        error: error.response
      });
    }
  };
};

export function getCompanyRegistrationDetails(role, companyId) {
  return (dispatch) => {
    dispatch({
      type: 'SET_LOADER',
      payload: true
    });

    axios({
      method: 'GET',
      url: USER_SERVICE_URL + USER_SERVICE_ENDPOINT.GET_COMPANY_REGISTRATION_DETAILS,
      params: {
        role: role,
        companyId: companyId
      },
      headers: {
        'X-tenant':
          store.getState().UserServiceReducer?.csmTenants?.tenantId ??
          process.env.REACT_APP_SELLER_TENANT_ID
      }
    })
      .then((response) => {
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
        dispatch({
          type: 'COMPANY_REGISTRATION_DETAILS',
          payload: response?.data
        });
      })
      .catch((error) => {
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
        dispatch({
          type: 'ERROR',
          error: error
        });
      });
  };
}

export function getCSMTenants() {
  return (dispatch) =>
    axios({
      method: 'GET',
      url: USER_SERVICE_URL + USER_SERVICE_ENDPOINT.GET_CSM_TENANTS
    })
      .then((response) => {
        dispatch({
          type: 'CSM_TENANTS',
          payload: response?.data
        });
      })
      .catch((error) => {
        dispatch({
          type: 'ERROR',
          error: error
        });
      });
}

export const getApprovedBuyersList = (pageSize, status) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_LOADER',
      payload: true
    });
    axios({
      method: 'GET',
      url: USER_SERVICE_URL + USER_SERVICE_ENDPOINT.GET_USERS,
      headers: {
        'X-tenant':
          store.getState().UserServiceReducer?.csmTenants?.tenantId ??
          process.env.REACT_APP_SELLER_TENANT_ID
      },
      params: {
        pageSize: pageSize,
        status: status
      }
    })
      .then((response) => {
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
        dispatch({
          type: 'APPROVED_BUYERS_LIST',
          payload: response?.data?.users
        });
      })
      .catch((error) => {
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
        dispatch({
          type: 'ERROR',
          error: error
        });
      });
  };
};

export function getCompanyDetailsBySearchTerm(searchTerm) {
  const term = btoa(utf8Encode(searchTerm));

  return (dispatch) => {
    dispatch({
      type: 'SET_LOADER',
      payload: true
    });
    axios({
      method: 'GET',
      url: USER_SERVICE_CAPABILITIES_URL + USER_SERVICE_ENDPOINT.SEARCH,
      headers: {
        'X-tenant':
          store.getState().UserServiceReducer?.csmTenants?.tenantId ??
          process.env.REACT_APP_SELLER_TENANT_ID
      },
      params: {
        term: term
      }
    })
      .then((response) => {
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
        dispatch({
          type: 'COMPANY_DETAILS_BY_SEARCH_TERM',
          payload: response?.data
        });
      })
      .catch((error) => {
        dispatch({
          type: 'SET_LOADER',
          payload: false
        });
        dispatch({
          type: 'ERROR',
          error: error
        });
      });
  };
}
